export default function mobileNav() {
    const burger = document.getElementById('burger__js');
    const nav = document.getElementById('headerNavigation__js');
    if (nav && burger) {
        const toggleOrigins = nav.querySelectorAll('.toggle-origin');
        if (toggleOrigins) {
            burger.addEventListener('click', () => {
                nav.toggleAttribute('data-nav-menu-open');
                document.body.toggleAttribute('mobile-nav-menu-open');
                toggleOrigins.forEach((el) => {
                    el.classList.toggle('w--open');
                });
            });

            window.onresize = () => {
                if (window.innerWidth >= 992) {
                    nav.removeAttribute('data-nav-menu-open');
                }
            };
        }
    }
}
